module.exports = __webpack_public_path__ + "img/relaxation.9dd67d14.jpg";